<template>
  <div>
    <v-form @submit.prevent="buscarEmpleado" class="d-flex justify-center align-center">
      <v-icon class="mr-2" v-if="!empleado">mdi-account</v-icon>
      <JerarquiaMedalla class v-if="empleado" :id="empleado.jerarquiaId"></JerarquiaMedalla>
      <v-text-field
        class
        @blur="buscarEmpleado"
        :label="label || 'DNI Empleado'"
        v-model="filtro"
        :hint="empleadoDescripcion || error"
        persistent-hint
        :error="!!error"
        :loading="loading"
      ></v-text-field>
    </v-form>
  </div>
</template>

<script>
import EmpleadoService from "../../services/Empleado.service";
import JerarquiaMedalla from "./JerarquiaMedalla";

export default {
  props: ["value", "label"],
  components: {
    JerarquiaMedalla,
  },
  data() {
    return {
      error: "",
      filtro: "",
      empleado: null,
      loading: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.filtro = val;
        this.buscarEmpleado();
      } else {
        this.filtro = "";
        this.empleado = null;
      }
    },
  },
  computed: {
    empleadoDescripcion: function () {
      if (!this.empleado) {
        return "";
      }
      return (
        this.empleado.jerarquia +
        " " +
        this.empleado.apellido +
        " " +
        this.empleado.nombre
      );
    },
  },
  methods: {
    buscarEmpleado() {
      if (this.filtro && this.filtro != "") {
        this.error = "";
        this.empleado = null;
        this.loading = true;
        EmpleadoService.ObtenerPorDni(this.filtro)
          .then((res) => {
            this.loading = false;
            this.empleado = res.data;
            this.$emit("input", +this.filtro);
          })
          .catch((err) => {
            this.loading = false;
            this.error = "Datos inválidos";
            this.$emit("input", null);
          });
      } else {
        this.filtro = "";
        this.empleado = null;
        this.$emit("input", null);
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>